import React, { forwardRef, useEffect, useImperativeHandle } from 'react'
import { makeStyles } from '@mui/styles'
import GeneralTaxSettings from '@/modules/settings/components/tax-settings/general/general-tax-settings'

const useStyles = makeStyles(() => ({
  wrapper: {
    paddingTop: 50,
    marginBottom: 50,
  },
}))

const TaxSettingsData = forwardRef(({ onSubmitted, onValid }, ref) => {
  const classes = useStyles()
  useImperativeHandle(ref, () => ({
    save: async() => {
      onSubmitted()
    },
  }))

  useEffect(() => {
    onValid(true)
  }, [])

  return (
    <div className={classes.wrapper}>
      <GeneralTaxSettings isOnboardingTester />
    </div>
  )
})

export default TaxSettingsData
